module.exports = __webpack_public_path__ + "img/departure-modal-icon.f6923b00.svg";